import { Injectable, inject } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SimpleGridResultModalComponent } from "../components/simple-grid-result-modal/simple-grid-result-modal.component";
import { ImageCarouselModalComponent } from "../components/image-carousel-modal.component/image-carousel-modal.component";

@Injectable({ providedIn: 'root' })
export class NovaSharedCommonService {

    ngbModal = inject(NgbModal);

    openDefaultKeyResultModal(data: any, opts: { keyColumnName: string, title?: string, titleIconClass?: string }): Promise<any> {
        const modal: NgbModalRef = this.ngbModal.open(SimpleGridResultModalComponent, { size: 'lg', scrollable: true, centered: true });

        modal.componentInstance.title = opts.title ?? '결과';
        modal.componentInstance.titleIconClass = opts.titleIconClass ?? '';
        modal.componentInstance.headers = [
            { name: opts.keyColumnName, width: 159, binding: 'key' },
            { name: '결과', width: '*', binding: 'message', align: "'Left'" }
        ]
        modal.componentInstance.data = data;

        return modal.result;
    }

    /**
     * 사진 상세보기
     */
    openImageModal(images: any[] = [], initialIndex = 0) {
        let modal = this.ngbModal.open(ImageCarouselModalComponent, { size: 'xl', scrollable: true, backdrop: 'static', windowClass: 'image-viewer-modal' });
        modal.componentInstance.images = images;
        modal.componentInstance.initialIndex = initialIndex;
        return modal.result;
    }
}
